import { Link } from "react-router-dom";
import { TestTube } from "lucide-react";
import { formatGBP, resolveImageUrl } from "../lib/api";

export const ProductCard = ({ product, onAdd }) => {
  const outOfStock = product.stock <= 0;
  const lowStock = product.stock > 0 && product.stock <= 5;
  const img = resolveImageUrl(product.image_url);

  return (
    <article
      data-testid={`product-card-${product.sku}`}
      className="group bg-white border border-[#E2E8F0] flex flex-col transition-colors hover:border-[#2C8C9C]"
    >
      <Link to={`/products/${product.id}`} className="block">
        <div className="aspect-square sb-grid-overlay border-b border-[#E2E8F0] flex items-center justify-center bg-[#F8FAFC] relative overflow-hidden">
          {img ? (
            <img
              src={img}
              alt={`${product.name} ${product.dosage}`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          ) : (
            <TestTube
              className="w-20 h-20 text-[#2C8C9C]/40 group-hover:text-[#2C8C9C] transition-colors"
              strokeWidth={1.25}
            />
          )}
          <div className="absolute top-3 left-3 sb-mono-label bg-white/90 px-1.5 py-0.5">{product.sku}</div>
          {outOfStock && (
            <div className="absolute top-3 right-3 sb-warning-tag bg-white px-2 py-0.5 border border-[#B91C1C]/20">
              Out of stock
            </div>
          )}
          {!outOfStock && lowStock && (
            <div className="absolute top-3 right-3 sb-warning-tag bg-white px-2 py-0.5 border border-[#B91C1C]/20">
              Only {product.stock} left
            </div>
          )}
        </div>
      </Link>

      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="text-lg font-medium text-[#1B3A5C]" style={{ fontFamily: "Outfit" }}>
            {product.name}
          </h3>
          <span className="font-mono text-xs text-[#475569]">{product.dosage}</span>
        </div>
        <p className="mt-2 text-sm text-[#475569] leading-relaxed flex-1">
          {product.short_description}
        </p>

        <div className="mt-5 flex items-center justify-between border-t border-[#E2E8F0] pt-4">
          <div>
            <div className="sb-mono-label">Price</div>
            <div className="text-xl font-semibold text-[#1B3A5C] mt-0.5" style={{ fontFamily: "Outfit" }}>
              {formatGBP(product.price_gbp)}
            </div>
          </div>
          <div className="text-right">
            <div className="sb-mono-label">Stock</div>
            <div data-testid={`product-stock-${product.sku}`} className="font-mono text-sm text-[#0F172A] mt-0.5">
              {product.stock}
            </div>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-2 gap-2">
          <Link
            to={`/products/${product.id}`}
            data-testid={`product-view-${product.sku}`}
            className="text-center text-sm font-medium border border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white px-3 py-2 transition-colors"
          >
            Details
          </Link>
          <button
            type="button"
            data-testid={`product-add-${product.sku}`}
            disabled={outOfStock}
            onClick={() => onAdd?.(product)}
            className="text-sm font-medium bg-[#1B3A5C] text-white hover:bg-[#254D7A] px-3 py-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {outOfStock ? "Sold out" : "Add to cart"}
          </button>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
